// The 'if' custom attribute only stamps the element and its children if the condition is truthy.
export const IF_CUSTOM_ATTRIBUTE_QUALIFIER = "if";